namespace Nobox.Membership {
    export interface SignUpForm {
        DisplayName: Serenity.StringEditor;
        Email: Serenity.EmailAddressEditor;
        Password: Serenity.PasswordEditor;
        ConfirmPassword: Serenity.PasswordEditor;
        MobilePhoneNumber: Serenity.MaskedEditor;
        CtryId: Serenity.ServiceLookupEditor;
        StatesId: StateLookupEditor;
        CityId: CityLookupEditor;
        Opt: Serenity.RadioButtonEditor;
        InvCd: Serenity.StringEditor;
        TnNm: Serenity.StringEditor;
        TnIdtry: Serenity.LookupEditor;
        TnIdtryNm: Serenity.StringEditor;
        TnSize: Serenity.LookupEditor;
        TnSizeNm: Serenity.StringEditor;
        Recaptcha: CustomRecaptcha;
    }

    export class SignUpForm extends Serenity.PrefixedContext {
        static formKey = 'Membership.SignUp';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SignUpForm.init)  {
                SignUpForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.EmailAddressEditor;
                var w2 = s.PasswordEditor;
                var w3 = s.MaskedEditor;
                var w4 = s.ServiceLookupEditor;
                var w5 = StateLookupEditor;
                var w6 = CityLookupEditor;
                var w7 = s.RadioButtonEditor;
                var w8 = s.LookupEditor;
                var w9 = CustomRecaptcha;

                Q.initFormType(SignUpForm, [
                    'DisplayName', w0,
                    'Email', w1,
                    'Password', w2,
                    'ConfirmPassword', w2,
                    'MobilePhoneNumber', w3,
                    'CtryId', w4,
                    'StatesId', w5,
                    'CityId', w6,
                    'Opt', w7,
                    'InvCd', w0,
                    'TnNm', w0,
                    'TnIdtry', w8,
                    'TnIdtryNm', w0,
                    'TnSize', w8,
                    'TnSizeNm', w0,
                    'Recaptcha', w9
                ]);
            }
        }
    }
}
